module.exports = __webpack_public_path__ + "static/media/mamabox.ba1cc2e0.png";